import { intl } from 'hellospa/common/hs-intl-provider';
import hsMessages from 'signer/components/common/translations/hs-messages';
import Field from './field';

export default Field.extend({
  /**
   */

  getValidationError() {
    if (this.required && !this.value) {
      return new Error(intl.formatMessage(hsMessages.requiredMessage));
    }
  },

  /**
   */

  hasValue() {
    return !!this.value;
  },

  /**
   */

  hasGroup() {
    return !!this.group && !this.group.root;
  },

  /**
   */

  setValue(v) {
    this.value = v;
    if (this.hasGroup() && this.hasValue()) {
      this.group.edited = true;
    }
  },
});
